import React from 'react';

const Partner = () => {
  const redirectTo = (url) => {
    window.location.href = url;
  };

  return (
    <div className="container-fluid pt-3 pb-3" style={{ backgroundColor: '#F2F2F2' }}>
      <div className="container bg-white rounded shadow">
        <div className="row justify-content-center">
          <div
            className="col-md-6"
            style={{
              backgroundImage: "url('https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/media/20170709_075703_1601910909.jpg')",
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
              minHeight: '400px',
            }}
          ></div>

          <div className="col-md-6 p-4 d-flex flex-column align-items-center justify-content-center">
            <h5 className="text-center font-weight-bold mb-4" style={{ color: '#324B8E' }}>
              Selezionare la tipologia di account
            </h5>

            <div className="row w-100 justify-content-center">
              {[
                {
                  img: 'https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/media/Icona_Turista.png',
                  label: 'UTENTE\nTURISTA',
                  onClick: () => redirectTo('registerFormTurista'),
                },
                {
                  img: 'https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/media/Icona_Ente.png',
                  label: 'OPERATORE DI\nSETTORE',
                  onClick: () => redirectTo('UserBusinessType'),
                },
                {
                  img: 'https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/media/Icona_Pubblica amm.png',
                  label: 'PUBBLICA\nAMMINISTRAZIONE',
                  onClick: () => redirectTo('registerFormEnte'),
                },
              ].map((item, index) => (
                <div key={index} className="col-lg-4 d-flex flex-column align-items-center mb-4">
                  <img src={item.img} className="w-50 mb-3" alt="Icon" />
                  <p className="text-center" style={{ color: '#000000', whiteSpace: 'pre-line' }}>
                    {item.label}
                  </p>
                  <button
                    className="btn w-75"
                    style={{
                      backgroundColor: '#007AFF',
                      color: '#FFFFFF',
                      border: 'none',
                      borderRadius: '6px',
                      padding: '10px',
                      fontWeight: 'bold',
                    }}
                    onClick={item.onClick}
                  >
                    Registrati
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Partner;
